import axios from 'axios';
import moment from 'moment';
import XLSX from 'xlsx';
const server = process.env.REACT_APP_SERVER_URL;

export const newReportPdf = async (data, token) => {
  let response, intervalResponse;
  try {
    const body = {
      from: moment(data.rango[0]).utcOffset('-4').startOf('day').toISOString(true),
      to: moment(data.rango[1]).utcOffset('-4').endOf('day').toISOString(true),
      alcaldia: data.alcaldia,
    };

    const id = await axios.post(`${server}/branches`, body, { headers: { Authorization: `Bearer ${token}` } });
    console.log(id);

    response = await new Promise((res, rej) => {
      const int = setInterval(async () => {
        intervalResponse = await axios.get(`${server}/branches/${id.data.data}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(intervalResponse.data);
        if (intervalResponse.status === 200) {
          res(intervalResponse);
          clearInterval(int);
        }
      }, 30000);
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const clouserAllCash = async (data) => {
  try {
    const response = await axios.post(
      `${server}/cashier/all`,
      {
        from: moment(data.rango[0]).utcOffset('-4').startOf('day').toISOString(true),
        to: moment(data.rango[1]).utcOffset('-4').endOf('day').toISOString(true),
      },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const closureCash = async (day) => {
  try {
    const response = await axios.post(
      `${server}/cashier`,
      { day },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const newReportExcel = async (data, token) => {
  try {
    const body = { from: data.rango[0], to: data.rango[1], ramo: data.ramo };
    const response = await axios.post(`${server}/settlements/report`, body, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const newReportExcelIVA = async (data, token) => {
  try {
    const body = { from: data.rango[0], to: data.rango[1], ramo: data.ramo };
    const response = await axios.post(`${server}/settlements/report/iva`, body, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportDAE = async (data, rim, token) => {
  try {
    const response = await axios.get(
      `${server}/definitive-declaration?tipoDocumento=${data.tipoDocumento}&documento=${data.documento}&referencia=${rim}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportTransf = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/reportTransf`, data, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportTransfBank = async (data, token, bankState) => {
  try {
    const response = await axios.post(`${server}/branches/reportTransfBank/${bankState}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const reportCondo = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/condoReport`, data, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportCondoDisclosed = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/condoReportDisclosed`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportTimeFunctionary = async (data, token) => {
  try {
    const response = await axios.post(`${server}/reportCPU/timeFunctionary`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    let reportData = response.data.data;

    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.json_to_sheet(reportData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1');
    XLSX.writeFile(workbook, 'ReporteTiempoPersonal.xlsx');

    return { status: 201 };
  } catch (error) {
    throw error;
  }
};

//t
export const reportPagosAprobados = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/reportPagosAprobados`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportPayments = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/reportPayments`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportEarnings = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/reportEarnings`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportEcodebaGlobalLiqPag = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/reportEcodebaRPR`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportTaxCredit = async (data, token) => {
  try {
    const response = await axios.post(`${server}/settlements/report/taxCredit`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportRejectedPayments = async (data, token) => {
  try {
    const response = await axios.post(`${server}/branches/reportRejectedPayments`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportTaxpayersDebtors = async (token) => {
  try {
    const response = await axios.post(`${server}/branches/reportTaxpayersDebtors`, { },{
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reportRegisteredTaxpayers = async (token) => {
  try {
    const response = await axios.post(
      `${server}/branches/reportRegisteredTaxpayers`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const reportTaxpayersNonFiler = async (token) => {
  try {
    const response = await axios.post(`${server}/branches/reportTaxpayersNonFiler`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};